module.exports = __webpack_public_path__ + "static/media/023admin_10 order complete @2x.c54e671e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/023admin_10 order complete @2x.png
// module id = 588
// module chunks = 0